export function formatIDR(value) {
  const n = Number(value || 0);
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export function formatShortIDR(value) {
  const n = Number(value || 0);
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `Rp ${(n / 1_000_000_000).toFixed(2)} M`;
  if (abs >= 1_000_000) return `Rp ${(n / 1_000_000).toFixed(1)} jt`;
  if (abs >= 1_000) return `Rp ${(n / 1_000).toFixed(0)} rb`;
  return "Rp " + n.toLocaleString("id-ID");
}

export function formatPercent(value) {
  const n = Number(value || 0);
  const sign = n > 0 ? "+" : "";
  return sign + n.toFixed(2) + "%";
}

const MONTHS_ID = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

export function periodLabel(period) {
  if (!period) return "";
  const [y, m] = period.split("-").map((v) => parseInt(v, 10));
  return `${MONTHS_ID[m - 1]} ${y}`;
}

export function periodShort(period) {
  if (!period) return "";
  const [y, m] = period.split("-").map((v) => parseInt(v, 10));
  return `${MONTHS_ID[m - 1].slice(0, 3)} ${String(y).slice(2)}`;
}

export function currentPeriod() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function prevPeriod(period) {
  const [y, m] = period.split("-").map((v) => parseInt(v, 10));
  if (m === 1) return `${y - 1}-12`;
  return `${y}-${String(m - 1).padStart(2, "0")}`;
}

export const MONTH_OPTIONS = MONTHS_ID.map((n, i) => ({
  value: String(i + 1).padStart(2, "0"),
  label: n,
}));

export function yearOptions() {
  const y = new Date().getFullYear();
  const arr = [];
  // Mulai 2025 hingga 15 tahun ke depan
  for (let i = y + 15; i >= 2025; i--) arr.push(i);
  return arr;
}
